import apiClient from './_axios';

/**
 * Basic portal (client.mysmartfi.ph) — the buyer's side of a client
 * sub-login. Sign-in returns a restricted token the server pins to one
 * device; it rides the same axios interceptor as normal auth.
 */

export interface ClientProfile {
   username: string;
   sellerEmail: string;
   deviceId: string;
   deviceName: string;
   /** Seller-controlled switches for what the buyer may change. */
   permissions?: { renameVendo?: boolean; renameSsid?: boolean };
}

export async function clientSignInApi(body: {
   sellerEmail: string;
   username: string;
   password: string;
}): Promise<{ token: string; client: ClientProfile }> {
   const r = await apiClient.post('/client/signin', body);
   return r.data;
}

export async function clientMeApi(): Promise<{ client: ClientProfile }> {
   const r = await apiClient.get('/client/me');
   return r.data;
}

export async function clientChangePasswordApi(body: {
   currentPassword: string;
   newPassword: string;
}): Promise<{ ok: boolean }> {
   const r = await apiClient.post('/client/change-password', body);
   return r.data;
}
